var map = {
	"./br/PT/S1/bg20.jpg": 81891,
	"./in/EN/S1/bg20.jpg": 95349,
	"./ph/EN/S1/bg20.jpg": 33528,
	"./vn/VI/S1/bg20.jpg": 95120
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48473;